const systemStaffRouter = [
  // 信息类型
  {
    path: '/system/staff/info-type',
    name: 'infoType',
    meta: { id: '/system/staff/info-type' },
    component: () => import('@/views/System/StaffManagement/Body/body.vue'),
  },
  {
    // 信息类型字段
    path: '/system/staff/info-type-fields',
    name: 'infoTypeFields',
    meta: { id: '/system/staff/info-type-fields' },
    component: () => import('@/views/System/StaffManagement/Body/body.vue'),
  },
  {
    // 工号设置
    path: '/system/staff/emp-id',
    name: 'empId',
    meta: { id: '/system/staff/emp-id' },
    component: () => import('@/views/System/StaffManagement/Body/body.vue'),
  },
  {
    // 员工状态
    path: '/system/staff/emp-status',
    name: 'empStatus',
    meta: { id: '/system/staff/emp-status' },
    component: () => import('@/views/System/StaffManagement/Body/body.vue'),
  },
  {
    // 员工类型
    path: '/system/staff/emp-type',
    name: 'empType',
    meta: { id: '/system/staff/emp-type' },
    component: () => import('@/views/System/StaffManagement/Body/body.vue'),
  },
  {
    // 人事范围
    path: '/system/staff/personnel-area',
    name: 'personnelArea',
    meta: { id: '/system/staff/personnel-area' },
    component: () => import('@/views/System/StaffManagement/Body/body.vue'),
  },
  {
    // 员工组
    path: '/system/staff/emp-group',
    name: 'empGroup',
    meta: { id: '/system/staff/emp-group' },
    component: () => import('@/views/System/StaffManagement/Body/body.vue'),
  },
  {
    // 异动类型
    path: '/system/staff/action-type',
    name: 'actionType',
    meta: { id: '/system/staff/action-type' },
    component: () => import('@/views/System/StaffManagement/Body/body.vue'),
  },
  {
    // 异动原因
    path: '/system/staff/action-reason',
    name: 'actionReason',
    meta: { id: '/system/staff/action-reason' },
    component: () => import('@/views/System/StaffManagement/Body/body.vue'),
  },
  {
    // 异动流程
    path: '/system/staff/action-process',
    name: 'actionProcess',
    meta: { id: '/system/staff/action-process' },
    component: () => import('@/views/System/StaffManagement/Body/body.vue'),
  },
  {
    // 性别
    path: '/system/staff/gender',
    name: 'gender',
    meta: { id: '/system/staff/gender' },
    component: () => import('@/views/System/StaffManagement/Body/body.vue'),
  },
  {
    // 婚姻状况
    path: '/system/staff/marital-status',
    name: 'maritalStatus',
    meta: { id: '/system/staff/marital-status' },
    component: () => import('@/views/System/StaffManagement/Body/body.vue'),
  },
  {
    // 地址类型
    path: '/system/staff/address-type',
    name: 'addressType',
    meta: { id: '/system/staff/address-type' },
    component: () => import('@/views/System/StaffManagement/Body/body.vue'),
  },
  {
    // 民族
    path: '/system/staff/nation',
    name: 'nation',
    meta: { id: '/system/staff/nation' },
    component: () => import('@/views/System/StaffManagement/Body/body.vue'),
  },
  {
    // 政治面貌
    path: '/system/staff/political-status',
    name: 'politicalStatus',
    meta: { id: '/system/staff/political-status' },
    component: () => import('@/views/System/StaffManagement/Body/body.vue'),
  },
  {
    // 招聘渠道
    path: '/system/staff/recruit-channel',
    name: 'recruitChannel',
    meta: { id: '/system/staff/recruit-channel' },
    component: () => import('@/views/System/StaffManagement/Body/body.vue'),
  },
  {
    // 支付类型
    path: '/system/staff/pay-type',
    name: 'payType',
    meta: { id: '/system/staff/pay-type' },
    component: () => import('@/views/System/StaffManagement/Body/body.vue'),
  },
  {
    // 银行
    path: '/system/staff/bank',
    name: 'bank',
    meta: { id: '/system/staff/bank' },
    component: () => import('@/views/System/StaffManagement/Body/body.vue'),
  },
  {
    // 家庭成员关系
    path: '/system/staff/family',
    name: 'family',
    meta: { id: '/system/staff/family' },
    component: () => import('@/views/System/StaffManagement/Body/body.vue'),
  },
  {
    // 合同类型
    path: '/system/staff/contract-type',
    name: 'contractType',
    meta: { id: '/system/staff/contract-type' },
    component: () => import('@/views/System/StaffManagement/Body/body.vue'),
  },
  {
    // 合同分配
    path: '/system/staff/contract-distribution',
    name: 'contractDistribution',
    meta: { id: '/system/staff/contract-distribution' },
    component: () => import('@/views/System/StaffManagement/Body/body.vue'),
  },
  {
    // 学历类型
    path: '/system/staff/education',
    name: 'education',
    meta: { id: '/system/staff/education' },
    component: () => import('@/views/System/StaffManagement/Body/body.vue'),
  },
  {
    // 学位
    path: '/system/staff/education-degree',
    name: 'educationDegree',
    meta: { id: '/system/staff/education-degree' },
    component: () => import('@/views/System/StaffManagement/Body/body.vue'),
  },
  {
    // 行业
    path: '/system/staff/industry',
    name: 'industry',
    meta: { id: '/system/staff/industry' },
    component: () => import('@/views/System/StaffManagement/Body/body.vue'),
  },
  {
    // 职称技能类型
    path: '/system/staff/skill-type',
    name: 'skillType',
    meta: { id: '/system/staff/skill-type' },
    component: () => import('@/views/System/StaffManagement/Body/body.vue'),
  },
  {
    // 职称技能等级
    path: '/system/staff/skill-degree',
    name: 'skillDegree',
    meta: { id: '/system/staff/skill-degree' },
    component: () => import('@/views/System/StaffManagement/Body/body.vue'),
  },
  {
    // 奖惩类型
    path: '/system/staff/reward',
    name: 'reward',
    meta: { id: '/system/staff/reward' },
    component: () => import('@/views/System/StaffManagement/Body/body.vue'),
  },
  {
    // 日期类型
    path: '/system/staff/date',
    name: 'date',
    meta: { id: '/system/staff/date' },
    component: () => import('@/views/System/StaffManagement/Body/body.vue'),
  },
  {
    // 发展项目类型
    path: '/system/staff/project-type',
    name: 'projectType',
    meta: { id: '/system/staff/project-type' },
    component: () => import('@/views/System/StaffManagement/Body/body.vue'),
  },
  {
    // 发展项目途径
    path: '/system/staff/project-way',
    name: 'projectWay',
    meta: { id: '/system/staff/project-way' },
    component: () => import('@/views/System/StaffManagement/Body/body.vue'),
  },
  {
    // 借款借物途径
    path: '/system/staff/loan-type',
    name: 'loanType',
    meta: { id: '/system/staff/loan-type' },
    component: () => import('@/views/System/StaffManagement/Body/body.vue'),
  },
  {
    // 伙伴类型
    path: '/system/staff/partner',
    name: 'partner',
    meta: { id: '/system/staff/partner' },
    component: () => import('@/views/System/StaffManagement/Body/body.vue'),
  },
  {
    // 交通工具类型
    path: '/system/staff/traffic-type',
    name: 'trafficType',
    meta: { id: '/system/staff/traffic-type' },
    component: () => import('@/views/System/StaffManagement/Body/body.vue'),
  },
  {
    // 语言类型
    path: '/system/staff/lang-type',
    name: 'langType',
    meta: { id: '/system/staff/lang-type' },
    component: () => import('@/views/System/StaffManagement/Body/body.vue'),
  },
  {
    // 熟练程度
    path: '/system/staff/level',
    name: 'level',
    meta: { id: '/system/staff/level' },
    component: () => import('@/views/System/StaffManagement/Body/body.vue'),
  },
  {
    // 工序
    path: '/system/staff/workload-proc',
    name: 'workloadProc',
    meta: { id: '/system/staff/workload-proc' },
    component: () => import('@/views/System/StaffManagement/Body/body.vue'),
  },
  {
    // 职称技能等级
    path: '/system/staff/performance-type',
    name: 'performanceType',
    meta: { id: '/system/staff/performance-type' },
    component: () => import('@/views/System/StaffManagement/Body/body.vue'),
  },
];
export default systemStaffRouter;
